import { t } from '@lingui/macro'
import { isAuthorized } from 'helpers'

export const getCRMRoutes = (userRoles, navigate) => {
  const has_business = isAuthorized(userRoles, ['business', 'admin'])
  return [
    {
      disabled: !has_business,
      label: t`Dashboard`,
      path: '/crm/dashboard',
      onClick: path => navigate(path)
    },
    {
      disabled: !has_business,
      label: t`Companies`,
      path: '/crm/companies',
      onClick: path => navigate(path)
    },
    {
      disabled: !has_business,
      label: t`Communication`,
      path: '/crm/communication',
      onClick: path => navigate(path)
    },
    {
      disabled: !has_business,
      label: t`Tasks`,
      path: '/crm/tasks',
      onClick: path => navigate(path)
    },
    {
      label: t`Schools`,
      path: '/crm/schools',
      onClick: path => navigate(path),
      disabled: true
    },
    {
      label: t`Groups`,
      path: '/crm/groups',
      onClick: path => navigate(path),
      disabled: true
    },
    {
      label: t`Star Customers`,
      path: '/crm/star-customers',
      onClick: path => navigate(path),
      disabled: true
    },
    {
      disabled: !has_business,
      label: t`Reports`,
      path: '/crm/reports',
      onClick: null,
      pages: has_business && [
        {
          label: t`Sales Report`,
          path: '/crm/reports/sales',
          onClick: path => navigate(path)
        }
      ]
    },
    {
      disabled: !has_business,
      label: t`Settings`,
      path: '/crm/settings',
      onClick: null,
      pages: has_business && [
        {
          label: t`Sponsor Types`,
          path: '/crm/settings/sponsor-types',
          onClick: path => navigate(path)
        },
        {
          label: t`Ticket Types`,
          path: '/crm/settings/tickets',
          onClick: path => navigate(path)
        },
        {
          label: t`Setup`,
          path: '/crm/settings/setup',
          onClick: path => navigate(path)
        }
      ]
    }
  ]
}
